import * as React from 'react';
const SvgDelete = props => (
  <svg
    fill="currentColor"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M17.975 2.142h-4.533v-1.5l-.625-.625H7.175L6.55.642v1.5H2.025l-.625.625v3.391h1.25l.792 13.817h13.116l.792-13.817h1.25V2.767zM7.808 1.267H12.2v.875H7.808zm7.575 17.458H4.617L3.9 6.158h12.192l-.717 12.567zM17.35 4.908H2.65V3.392h14.708v1.516z" />
    <path d="M10.625 8.308h-1.25v8.267h1.25zM7.475 8.308h-1.25v8.267h1.25zM13.775 8.308h-1.25v8.267h1.25z" />
  </svg>
);
export default SvgDelete;
